import { ActivatedRoute, Params } from '@angular/router';
import { AfterContentInit, Component, OnInit } from '@angular/core';
import { ControllerForViewBase } from '../../framework/controller-for-view-base';
import { PageContainerService } from '../../../services';
import { IsUserAuthenticatedCommandResponse, LoginCommandRequest } from '../../../data/CommandServiceDtos.generated';

@Component({
  standalone: false,
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends ControllerForViewBase implements OnInit {
  formModel: LoginCommandRequest = new LoginCommandRequest();
  private redirectRoute: string;

  constructor(pcs: PageContainerService, private activatedRoute: ActivatedRoute) {
    super(pcs);
    var that = this;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      that.redirectRoute = params['redirectRoute'];
    });
  }

  ngOnInit() {
    this.pcs.apiService.IsUserAuthenticated({}, true, false).then((response: IsUserAuthenticatedCommandResponse) => {
      if (response.IsAuthenticated) {
        this.pcs.clientSessionService.loginUser(response.UserInfo);
        if (this.redirectRoute) {
          this.pcs.router.navigateByUrl(this.redirectRoute);
        } else {
          this.pcs.router.navigate(['projects']);
        }
      }
    });
  }

  async login() {
    this.pcs.notificationService.removeAll();
    let response = await this.pcs.apiService.Login(this.formModel, undefined, true);
    this.pcs.clientSessionService.loginUser(response.UserInfo);
    if (this.redirectRoute !== '' && this.redirectRoute != null && !this.redirectRoute.startsWith('/login')) {
      this.pcs.router.navigateByUrl(this.redirectRoute);
    }
    else {
      this.pcs.router.navigate(['projects']);
    }
  }
}
